import React from 'react'
import { MlImages, Image, Video, Model3d, AspectRatio } from '../../molecules'
import dynamic from 'next/dynamic'

type ImageMedia = { type: 'image'; className?: string; aspectRatio?: AspectRatio; changeDimension?: boolean } & Image
type VideoMedia = { type: 'video'; className?: string } & Video
type Model3dMedia = { type: 'model3d'; className?: string } & Model3d

export type Media = ImageMedia | VideoMedia | Model3dMedia


export const withAspectRatio = (media: Media, aspectRatio: AspectRatio): Media =>
  media.type === 'image' ? { ...media, aspectRatio } : media

const DynamicModel3dLoader = dynamic(() => import('../../molecules').then((mod) => mod.MlModel3d), {
  ssr: false,
  loading: () => (
    <div className="w-[50px] h-[50px] animate-spin rounded-full border-2 border-current border-t-transparent" />
  ),
})

const DynamicVideoPlayerLoader = dynamic(() => import('../../molecules').then((mod) => mod.MlVideoPlayer), {
  ssr: false,
  loading: () => (
    <div className="w-[50px] h-[50px] animate-spin rounded-full border-2 border-current border-t-transparent" />
  ),
})

export const OrMedia: React.FC<Media> = (props) => {
  switch (props.type) {
    case 'image':
      return (
        <MlImages
          unsetMaxDimensions
          changeDimension={props.changeDimension}
          images={[{ ...props }]}
          aspectRatio={props.aspectRatio ?? 'custom'}
          className={props.className}
        />
      )
    case 'model3d':
      return (
        <div className={`w-full h-full object-cover ${props.className}`}>
          <DynamicModel3dLoader {...props} />
        </div>
      )
    case 'video':
      return (
        <div className={`w-full h-full object-cover ${props.className}`}>
          <DynamicVideoPlayerLoader {...props} />
        </div>
      )
    default:
      return null
  }
}
